
import {
  defineComponent,
  defineAsyncComponent,
  onMounted,
} from 'vue';

import type {
  EntriesPaginator,
  QualityPresets,
  Statistics,
  GenericObject,
} from '@/types';

import useEntriesNext from '@/composable/useEntries@next';

import useSubStatisticsComponent from '@/composable/useSubStatisticsComponent';

import useCampaignSubids from '@/composable/useCampaignSubids';

import StatisticsBy from '@/components/Statistics/Staff/StatisticsBy.vue';

export default defineComponent({
  extends: StatisticsBy,
  components: {
    // Компоненты колонок
    EfficiencyColumn: defineAsyncComponent(() => import('@/components/Statistics/Staff/Columns/EfficiencyColumn.vue')),
    RequestsColumn: defineAsyncComponent(() => import('@/components/Statistics/Staff/Columns/RequestsColumn.vue')),
    ViewsColumn: defineAsyncComponent(() => import('@/components/Statistics/Staff/Columns/ViewsColumn.vue')),
    FeedsRequestsColumn: defineAsyncComponent(() => import('@/components/Statistics/Staff/Columns/FeedsRequestsColumn.vue')),
    ClicksColumn: defineAsyncComponent(() => import('@/components/Statistics/Staff/Columns/ClicksColumn.vue')),
    ImpressionsColumn: defineAsyncComponent(() => import('@/components/Statistics/Staff/Columns/ImpressionsColumn.vue')),
    CTRColumn: defineAsyncComponent(() => import('@/components/Statistics/Staff/Columns/CTRColumn.vue')),
    Subid: defineAsyncComponent(() => import('@/components/Subid.vue')),
    CampaignSubidControls: defineAsyncComponent(() => import('@/components/CampaignSubidControls.vue')),
    // Компоненты статистики
    StatisticsByFilteredClicks: defineAsyncComponent(() => import('@/components/Statistics/Staff/StatisticsByFilteredClicks.vue')),
    StatisticsByFilteredImpressions: defineAsyncComponent(() => import('@/components/Statistics/Staff/StatisticsByFilteredImpressions.vue')),
  },
  setup(props) {
    const {
      entries: statistics,
      entriesLoading: statisticsLoading,
      entriesFetched: statisticsFetched,
      fetchEntries: fetchStatistics,
    } = useEntriesNext<Statistics>('/api/statistics/staff/getStatisticsBySubids');

    const {
      entries: qualityPresets,
      entriesFetched: qualityPresetsFetched,
      fetchEntries: fetchQualityPresets,
    } = useEntriesNext<QualityPresets>('/api/quality-preset/getQualityPresets');

    const {
      subStatisticsComponent,
      setSubStatisticsComponent,
      resetSubStatisticComponent,
    } = useSubStatisticsComponent();

    const campaignSubids = useCampaignSubids(props.statisticsFilters);

    const fetchStatisticsWrapper = async (subidsPaginator: EntriesPaginator): Promise<void> => {
      fetchStatistics({
        ...props.statisticsFilters,
        ...props.filters,
        ...subidsPaginator,
      });

      campaignSubids.fetchSettings();

      resetSubStatisticComponent();
    };

    // Заблокированный субайд красит строку поверх выбранной: в style.css его правило идёт следом
    const getStatisticBySubidRowClass = (row: GenericObject): string => [
      row.subid_uuid === subStatisticsComponent.filters.subid_uuid ? 'statistics-table-row-active' : '',
      campaignSubids.subidRowClass(row.subid_uuid),
    ].filter(Boolean).join(' ');

    onMounted((): Promise<void> => fetchQualityPresets());

    return {
      statistics,
      statisticsLoading,
      statisticsFetched,
      qualityPresets,
      qualityPresetsFetched,
      fetchStatisticsWrapper,
      subStatisticsComponent,
      setSubStatisticsComponent,
      campaignSubids,
      getStatisticBySubidRowClass,
    };
  },
});
